import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function FutureServices() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div
          ref={ref}
          className={`transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="max-w-2xl mx-auto">
            <div className="bg-[#F0FAF0] rounded-3xl p-12 text-center border border-eco-green/10 relative overflow-hidden">
              {/* Decorative circle */}
              <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-eco-green/5" />
              <div className="absolute -bottom-12 -left-12 w-36 h-36 rounded-full bg-eco-green/8" />

              <div className="relative z-10">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-eco-green/10 mx-auto mb-6">
                  <i className="ri-time-line text-3xl text-eco-green" />
                </div>

                <span className="inline-flex items-center gap-2 text-eco-green text-xs font-bold uppercase tracking-[0.2em] mb-4">
                  Peagi saadaval
                </span>

                <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-5">
                  Tulekul
                </h2>

                <p className="text-gray-600 text-base leading-relaxed mb-6">
                  Peagi avame{' '}
                  <strong className="text-dark-green">
                    platvormi kasutatud ehitusmaterjalide ja ehitusjääkide ostuks ja müügiks
                  </strong>
                  .
                </p>

                <div className="flex flex-wrap justify-center gap-3 mb-8">
                  {['Kasutatud ehitusmaterjalid', 'Ehitusjäägid', 'Taaskasutatud tooted'].map((tag) => (
                    <span
                      key={tag}
                      className="bg-white text-dark-green text-xs font-semibold px-4 py-2 rounded-full border border-eco-green/20"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <p className="text-eco-green text-sm font-semibold">
                  Tule peagi tagasi, et näha uuendusi →
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
